export const BurgerIcon = (props) => (
  <svg fill="none" height="25" viewBox="2 2 20 20" width="25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 18L20 18" stroke="#000000" strokeLinecap="round" strokeWidth="2" />
    <path d="M4 12L20 12" stroke="#000000" strokeLinecap="round" strokeWidth="2" />
    <path d="M4 6L20 6" stroke="#000000" strokeLinecap="round" strokeWidth="2" />
  </svg>
);
